/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
export const fastBackground = (p, color) => {
  const ctx = p._renderer.drawingContext;
  const curFill = ctx.fillStyle;
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  p._renderer.drawingContext.fillStyle = curFill;
};

export const fastFill = (p, color) => { p._renderer.drawingContext.fillStyle = color; };

export const fastStroke = (p, color) => { p._renderer.drawingContext.strokeStyle = color; };
/* eslint-enable no-underscore-dangle */
/* eslint-enable no-param-reassign */

const shorthandHexRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
const hexRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

/** Expand shorthand hex colors to full form */
const expandShorthandHex = hex => hex.trim()
  .replace(shorthandHexRegex, (match, r, g, b) => `${r}${r}${g}${g}${b}${b}`);

const parseHex = hexString => parseInt(hexString, 16);

/** Convert a hex color string to an rgb() color string */
const hexToRGB = (colorString) => {
  const match = hexRegex.exec(expandShorthandHex(colorString));
  return match ?
    `rgb(${parseHex(match[1])},${parseHex(match[2])},${parseHex(match[3])})` :
    colorString;
};

/** Convert a hex or rgb() color string & an opacity value to an rgba() string */
export const rgbaColor = (hexOrRGB, opacity) => hexToRGB(hexOrRGB)
  .replace(/rgb\(/, 'rgba(')
  .replace(/\)$/, `,${opacity.toFixed(2)})`);



// WEBPACK FOOTER //
// ./util/color.js